import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { ENGINEERING_TAB_ITEMS } from './engineeringTabItems';
import '../technical/HeatProfilePage.css';

/**
 * Engineering sub-tabs (same visual pattern as TechnicalSubTabs).
 * Currently: Coil Configurator. Add more items in engineeringTabItems.js.
 */
const EngineeringSubTabs = () => {
  const history = useHistory();
  const location = useLocation();
  const currentPath = location.pathname;

  const isActive = (path) => {
    if (path === '/engineering') {
      return currentPath === '/engineering' || currentPath === '/coil-configurator';
    }
    return currentPath === path || currentPath.startsWith(`${path}/`);
  };

  const handleTabClick = (path) => {
    if (path !== currentPath) {
      history.push(path);
    }
  };

  return (
    <div className="heat-profile-tabs-container">
      <div className="heat-profile-tabs">
        {ENGINEERING_TAB_ITEMS.map((item) => (
          <div
            key={item.id}
            className={`heat-profile-tab-item ${isActive(item.path) ? 'active' : ''}`}
            onClick={() => handleTabClick(item.path)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleTabClick(item.path);
              }
            }}
            role="tab"
            tabIndex={0}
            aria-selected={isActive(item.path)}
          >
            {item.icon}
            {item.label}
          </div>
        ))}
      </div>
    </div>
  );
};

export default EngineeringSubTabs;
